<ion-header class="ion-no-shadow ion-no-border">
    <header-notifications></header-notifications>
    <ion-toolbar class="ion-hide-xl-up">
        <!-- <a *ngIf="plt.eventsCount > 1"
           (click)="plt.openEventMenu()"
           class="change-event">
            <svg-icon [applyClass]="true"
                      src="/assets/icons/change-event.svg"></svg-icon>
            <ion-badge *ngIf="plt.unreadOtherCount"
                       class="notification">
                {{ plt.unreadOtherCount }}
            </ion-badge>
        </a> -->
        <ion-title [innerHTML]="'APPOINTMENTS_HEADER_MOBILE' | trns"></ion-title>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-no-padding">
    <ion-refresher (ionRefresh)="refresh($event)"
                   slot="fixed">
        <ion-refresher-content></ion-refresher-content>
    </ion-refresher>

    <app-out-link></app-out-link>

    <div class="content-box appointments black-header"
         *ngIf="!loading">

        <ion-row *ngIf="!plt.tabMenu"
                 class="ion-no-padding ion-align-items-center">
            <ion-col size="9"
                     class="ion-no-padding">
                <h1 [innerHTML]="'APPOINTMENTS_HEADER' | trns : {event: event?.translate(event?.default_locale).name}"></h1>
            </ion-col>
            <ion-col size="3"
                     class="ion-no-padding ion-text-right">
                <ion-button *ngIf="event.use_timeslots"
                            class="set-availability"
                            [routerLink]="['/timeslots']">
                    {{ 'APPOINTMENTS_SET_AVAILABILITY' | trns }}
                </ion-button>
            </ion-col>
        </ion-row>
        <ion-row *ngIf="plt.tabMenu && event.use_timeslots"
                 class="ion-no-padding ion-align-items-center">
            <ion-col size="12"
                     class="ion-no-padding ion-text-center">
                <a class="top-header-link"
                   [routerLink]="['/timeslots']">
                    <svg-icon [applyClass]="true"
                              src="/assets/icons/ico-appointments.svg"
                              class="icon fill-light"></svg-icon>
                    {{ 'APPOINTMENTS_SET_AVAILABILITY' | trns }}
                </a>
            </ion-col>
        </ion-row>
        <div class="content-box-inner">
            <div class="content-header">
                <ion-grid class="ion-no-padding">
                    <ion-row class="ion-no-padding">
                        <ion-col size="9">
                            <svg-icon [applyClass]="true"
                                      src="/assets/icons/ico-appointments.svg"
                                      class="icon fill-light"></svg-icon>
                            <ion-label *ngIf="scheduledAppointmentCount"
                                       [innerHTML]="'APPOINTMENTS_HEADER_LABEL' | trns:{count: scheduledAppointmentCount}"></ion-label>
                            <ion-label *ngIf="!scheduledAppointmentCount"
                                       [innerHTML]="'APPOINTMENTS_HEADER_LABEL_NO_SCHEDULED' | trns"></ion-label>
                        </ion-col>
                        <ion-col size="3"
                                 class="ion-text-right">
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </div>

            <div class="content-data">
                <div *ngIf="deletedAppointmentsCount > 0"
                     class="panel-info">
                    <div class="panel-body"
                         *ngIf="deletedAppointmentsCount == 1">
                        {{ 'APPOINTMENTS_ONE_PARTICIPANT_DELETED' | trns:{ value: deletedAppointmentsCount }
                        }}
                    </div>
                    <div class="panel-body"
                         *ngIf="deletedAppointmentsCount > 1">
                        {{ 'APPOINTMENTS_MULTIPLE_PARTICIPANTS_DELETED' | trns:{ value:
                        deletedAppointmentsCount } }}
                    </div>
                </div>
                <div class="list unprocessed"
                     *ngIf="unprocessedAppointments?.length">
                    <div class="header">
                        <h2 *ngIf="unprocessedAppointments?.length == 1"
                            [innerHTML]="'APPOINTMENTS_UNPROCESSED_LABEL' | trns:{count: unprocessedAppointments?.length}"></h2>
                        <h2 *ngIf="unprocessedAppointments?.length != 1"
                            [innerHTML]="'APPOINTMENTS_UNPROCESSED_LABEL_MULTI' | trns:{count: unprocessedAppointments?.length}"></h2>
                    </div>

                    <ion-grid class="ion-no-padding">
                        <ion-row class="item"
                                 *ngFor="let appointment of unprocessedAppointments"
                                 [ngClass]="{'with-invited': appointment.participants?.length >= 3}">
                            <ion-col align-self-start
                                     size="12"
                                     size-md="9">
                                <ng-container *ngIf="appointment.participants?.length < 3">
                                    <span *ngFor="let participant of appointment.participants"
                                          [hidden]="participant.id === user.selected_participant_id">
                                        <p>
                                            {{ 'APPOINTMENTS_INVITATION_TEXT' | trns }}
                                            <ng-container *ngIf="canProfileDetails(participant)">
                                                <a class=""
                                                   (click)="showParticipantDetail(participant);">
                                                    {{ participant.firstname }} {{ participant.lastname }}
                                                </a>
                                            </ng-container>
                                            <ng-container *ngIf="!canProfileDetails(participant)">
                                                {{ participant.firstname }} {{ participant.lastname }}
                                            </ng-container>
                                            <ng-container *ngIf="!appointment.date_ends_at">
                                                <span [innerHTML]=" 'APPOINTMENTS_INVITATION_TEXT_2_PART' | trns:{
                                                       date: (appointment.date_starts_at | datex: 'dateFormatDefault'),
                                                       time: (appointment.date_starts_at | datex: 'timeFormatDefaultEnd'),
                                                       place: appointment.location} "></span>
                                            </ng-container>
                                            <ng-container *ngIf="appointment.date_ends_at">
                                                <span [innerHTML]=" 'APPOINTMENTS_INVITATION_TEXT_2_PART_WITH_END' | trns:{
                                                       date: (appointment.date_starts_at | datex: 'dateFormatDefault'),
                                                       time: (appointment.date_starts_at | datex: 'timeFormatDefault'),
                                                       time_end: (appointment.date_ends_at | datex: 'timeFormatDefaultEnd'),
                                                       place: appointment.location} "></span>
                                            </ng-container>
                                        </p>
                                    </span>
                                </ng-container>

                                <ng-container *ngIf="appointment.participants?.length >= 3">
                                    <p>
                                        {{ 'APPOINTMENTS_INVITATION_TEXT' | trns }}
                                        <span class="participant-pictures pointer"
                                              (click)="openAppointmentParticipants($event, appointment)">
                                            <ng-container *ngFor="let participant of appointment.participants; let i = index">
                                                <ion-avatar *ngIf="i < 3">
                                                    <img class="avatar"
                                                         img-avatar
                                                         [src]="user?.canPicture(participant) ? participant.picture_url : ''"
                                                         title="{{ participant.firstname }} {{ participant.lastname }}"
                                                         alt="">
                                                </ion-avatar>
                                            </ng-container>
                                            <span *ngIf="!plt.sizeSm"
                                                  class="more">{{ 'BUTTON_SHOW_ALL' | trns }}</span>
                                        </span>
                                    </p>
                                    <p>
                                        <ng-container *ngIf="!appointment.date_ends_at">
                                            <span [innerHTML]=" 'APPOINTMENTS_INVITATION_TEXT_2_PART' | trns:{
                                             date: (appointment.date_starts_at | datex: 'dateFormatDefault'),
                                             time: (appointment.date_starts_at | datex: 'timeFormatDefaultEnd'),
                                             place: appointment.location} "></span>
                                        </ng-container>
                                        <ng-container *ngIf="appointment.date_ends_at">
                                            <span [innerHTML]=" 'APPOINTMENTS_INVITATION_TEXT_2_PART_WITH_END' | trns:{
                                             date: (appointment.date_starts_at | datex: 'dateFormatDefault'),
                                             time: (appointment.date_starts_at | datex: 'timeFormatDefault'),
                                             time_end: (appointment.date_ends_at | datex: 'timeFormatDefaultEnd'),
                                             place: appointment.location} "></span>
                                        </ng-container>
                                    </p>
                                </ng-container>

                                <p class="description"
                                   *ngIf="appointment.description">
                                    “{{ appointment.description }}” | “
                                    <ng-container *ngIf="appointment.online && (appointment.participants?.length <= 2 || appointment.participantStatus === 1)">
                                        <a (click)="openCall(appointment)"> {{'ATTENDEE_DETAIL_CALL_START' | trns}}</a>
                                    </ng-container>
                                    <ng-container *ngIf="appointment.online && appointment.participants?.length > 2 && appointment.participantStatus !== 1">{{'ATTENDEE_DETAIL_CALL_START' |
                                        trns}}</ng-container>
                                    <ng-container *ngIf="!appointment.online">{{appointment.location}}</ng-container>
                                    ”
                                </p>
                            </ion-col>
                            <ion-col size="12"
                                     size-md="3"
                                     class="buttons">
                                <ion-button (click)="openAnswerAppointment(appointment, 1)"
                                            color="primary">
                                    {{ 'BUTTON_ACCEPT' | trns }}
                                </ion-button>
                                <ion-button (click)="openAnswerAppointment(appointment, 2)"
                                            class="decline">
                                    {{ 'BUTTON_DECLINE' | trns }}
                                </ion-button>
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </div>

                <div class="list processed">
                    <div class="header">
                        <ion-grid class="ion-padding-top">
                            <ion-row class="ion-no-padding ion-align-items-center">
                                <ion-col size="7"
                                         class="ion-no-padding">
                                    <h2 *ngIf="!selectedAppointmentId"
                                        [innerHTML]="'APPOINTMENTS_PROCESSED_LABEL' | trns"></h2>
                                    <h2 *ngIf="selectedAppointmentId"
                                        [innerHTML]="'APPOINTMENTS_DETAIL_LABEL' | trns"></h2>
                                </ion-col>

                                <ng-container *ngIf="processedAppointments?.length || filterUsed()">
                                    <ng-container *ngIf="!showAllButton">
                                        <ion-col *ngIf="!plt.sizeSm"
                                                 size="3"
                                                 class="ion-no-padding">
                                            <ion-searchbar [placeholder]="'APPOINTMENTS_SEARCH_PLACEHOLDER' | translate"
                                                           [(ngModel)]="searchTerm"
                                                           (ionChange)="applyFilter($event)"></ion-searchbar>
                                        </ion-col>
                                        <ion-col class="ion-no-padding ion-text-right ion-align-self-center">
                                            <ion-select [interface]="selectType"
                                                        [interfaceOptions]="{cssClass: 'not-overflow'}"
                                                        [cancelText]="'BUTTON_CANCEL' |  translate"
                                                        (ionChange)="applyFilter()"
                                                        name="filterStatusValue"
                                                        class="filter-select"
                                                        #statusValue="ngModel"
                                                        [(ngModel)]="filterStatusValue">
                                                <ion-select-option [value]="'all'">{{ 'APPOINTMENTS_FILTER_STATUS_ALL' | trns }}</ion-select-option>
                                                <ion-select-option [value]="'pending'">{{ 'APPOINTMENTS_STATUS_PENDING' | trns }}</ion-select-option>
                                                <ion-select-option *ngIf="event.use_timeslots"
                                                                   [value]="'personal'">{{ 'APPOINTMENTS_STATUS_PERSONAL' | trns }}</ion-select-option>
                                                <ion-select-option [value]="'confirmed'">{{ 'APPOINTMENTS_STATUS_CONFIRMED' | trns }}</ion-select-option>
                                                <ion-select-option [value]="'canceled'">{{ 'APPOINTMENTS_STATUS_CANCELED' | trns }}</ion-select-option>
                                            </ion-select>
                                        </ion-col>
                                    </ng-container>

                                    <ng-container *ngIf="showAllButton">
                                        <ion-col size="5"
                                                 class="ion-no-padding ion-text-right">
                                            <ion-button class="ion-no-margin"
                                                        color="primary"
                                                        (click)="showAll()">
                                                {{ 'BUTTON_SHOW_ALL' | trns }}
                                            </ion-button>
                                        </ion-col>
                                    </ng-container>
                                </ng-container>

                            </ion-row>
                        </ion-grid>
                    </div>

                    <ng-container *ngIf="processedAppointments?.length">
                        <ion-grid *ngIf="!plt.sizeSm"
                                  class="ion-no-padding">
                            <ion-row class="order-row">
                                <ion-col class="col-30p">
                                    {{ 'APPOINTMENTS_HEADER_WITH_WHOM' | trns }}
                                    <span class="order-box">
                                        <a (click)="orderBy('name:asc')"
                                           class="order asc"
                                           [ngClass]="{active: order == 'name:asc' }">
                                            <svg-icon [applyClass]="true"
                                                      src="/assets/icons/ico-arrow.svg"></svg-icon>
                                        </a>
                                        <a (click)="orderBy('name:desc')"
                                           class="order desc"
                                           [ngClass]="{active: order == 'name:desc' }">
                                            <svg-icon [applyClass]="true"
                                                      src="/assets/icons/ico-arrow.svg"></svg-icon>
                                        </a>
                                    </span>
                                </ion-col>
                                <ion-col class="col-15p">
                                    {{ 'APPOINTMENTS_HEADER_TIME' | trns }}
                                    <span class="order-box">
                                        <a (click)="orderBy('starts_at:asc')"
                                           class="order asc"
                                           [ngClass]="{active: order == 'starts_at:asc' }">
                                            <svg-icon [applyClass]="true"
                                                      src="/assets/icons/ico-arrow.svg"></svg-icon>
                                        </a>
                                        <a (click)="orderBy('starts_at:desc')"
                                           class="order desc"
                                           [ngClass]="{active: order == 'starts_at:desc' }">
                                            <svg-icon [applyClass]="true"
                                                      src="/assets/icons/ico-arrow.svg"></svg-icon>
                                        </a>
                                    </span>
                                </ion-col>
                                <ion-col class="col-15p">
                                    {{ 'APPOINTMENTS_HEADER_LOCATION' | trns }}
                                </ion-col>
                                <ion-col class="col-15p">
                                    {{ 'APPOINTMENTS_HEADER_NOTE' | trns }}
                                </ion-col>
                                <ion-col class="col-15p">
                                    {{ 'APPOINTMENTS_HEADER_STATUS' | trns }}
                                </ion-col>
                                <ion-col class="col-10p">

                                </ion-col>
                            </ion-row>

                            <ng-container *ngFor="let appointment of processedAppointments">
                                <ion-row class="item ion-align-items-center with-invited">
                                    <ion-col class="col-25p">

                                        <ng-container *ngIf="appointment.status == 4">
                                            <span class="flex">
                                                <ion-avatar class="ion-align-self-center">
                                                    <img img-avatar
                                                         src="/assets/icons/private-lock.svg">
                                                </ion-avatar>
                                                <ion-label class="ion-align-self-center">{{ 'APPOINTMENTS_PERSONAL_APPOINTMENT' | trns }}</ion-label>
                                            </span>
                                        </ng-container>

                                        <ng-container *ngIf="appointment.status != 4">
                                            <div class="participant-pictures pointer">
                                                <ng-container *ngFor="let attendee of appointment.participants; let i = index">
                                                    <span *ngIf="(i < 2 && (appointment.participantStatus === 0 || appointment.participantStatus === 1)) || (i < 3 && appointment.participantStatus != 0 && appointment.participantStatus != 1)"
                                                          class="flex"
                                                          [hidden]="attendee.id == user.selected_participant_id && appointment.participants?.length < 3"
                                                          (click)="showAttendeeDetail(attendee)">
                                                        <ion-avatar class="ion-align-self-center">
                                                            <img img-avatar
                                                                 [src]="user?.canPicture(attendee) ? attendee.picture_url : ''"
                                                                 [title]="attendee.getFullName()">
                                                        </ion-avatar>
                                                    </span>
                                                </ng-container>
                                                <span *ngIf="appointment.participantStatus === 0 || appointment.participantStatus === 1"
                                                      class="flex add-participant"
                                                      (click)="addParticipants(appointment)">
                                                    +
                                                </span>
                                                <span *ngIf="appointment.participants?.length >= 3"
                                                      class="more"
                                                      (click)="openAppointmentParticipants($event, appointment)">
                                                    {{ 'BUTTON_SHOW_ALL' | trns }}
                                                </span>
                                                <ng-container *ngIf="appointment.participants?.length < 3">
                                                    <ng-container *ngFor="let attendee of appointment.participants; let i = index">
                                                        <span *ngIf="attendee.id != user.selected_participant_id"
                                                              (click)="showAttendeeDetail(attendee)"
                                                              class="more">
                                                            {{ attendee.getFullName() | cut:22:'...':false }}
                                                            <ng-container *ngIf="attendee.company"><br /><span class="company">{{attendee.company}}</span></ng-container>
                                                        </span>
                                                    </ng-container>
                                                </ng-container>
                                            </div>
                                        </ng-container>

                                    </ion-col>
                                    <ion-col class="col-20p">
                                        <ng-container *ngIf="!appointment.date_ends_at">
                                            {{ appointment.date_starts_at | datex: 'dateFormatDefault' }} – {{ appointment.date_starts_at | datex: 'timeFormatDefault' }}
                                        </ng-container>
                                        <ng-container *ngIf="appointment.date_ends_at">
                                            {{ appointment.date_starts_at | datex: 'dateFormatDefault' }}<br />
                                            {{ appointment.date_starts_at | datex: 'timeFormatDefault' }} - {{ appointment.date_ends_at | datex: 'timeFormatDefault' }}
                                        </ng-container>
                                    </ion-col>
                                    <ion-col class="col-15p">
                                        <ng-container *ngIf="appointment.online && (appointment.participants?.length <= 2 || appointment.participantStatus === 1)">
                                            <a (click)="openCall(appointment)"> {{'ATTENDEE_DETAIL_CALL_START' | trns}}</a>
                                        </ng-container>
                                        <ng-container *ngIf="appointment.online && appointment.participants?.length > 2 && appointment.participantStatus !== 1">{{'ATTENDEE_DETAIL_CALL_START' |
                                            trns}}</ng-container>
                                        <ng-container *ngIf="!appointment.online">{{appointment.location}}</ng-container>
                                    </ion-col>
                                    <ion-col class="col-15p">{{ appointment.description }}</ion-col>
                                    <ion-col class="status col-15p">
                                        <span class="pending"
                                              *ngIf="appointment.participantStatus === 0"><span class="dot"></span>{{ 'APPOINTMENTS_STATUS_PENDING' | trns }}</span>
                                        <span class="confirmed"
                                              *ngIf="appointment.participantStatus === 1"><span class="dot"></span>{{ 'APPOINTMENTS_STATUS_CONFIRMED' | trns }}</span>
                                        <span class="personal"
                                              *ngIf="appointment.status === 4"><span class="dot"></span>{{ 'APPOINTMENTS_STATUS_PERSONAL' | trns }}</span>
                                        <span class="canceled"
                                              *ngIf="appointment.participantStatus === 2 || appointment.participantStatus === 3"><span class="dot"></span>{{ 'APPOINTMENTS_STATUS_CANCELED' | trns
                                            }}</span>
                                    </ion-col>
                                    <ion-col class="more col-10p last">
                                        <ng-container *ngIf="!appointment.past && (appointment.participantStatus === 1 || appointment.status === 4 )">
                                            <a *ngIf="appointment.participantStatus === 1  && !appointment.past"
                                               (click)="download(appointment);"
                                               data-container="body"
                                               title="{{ 'APPOINTMENTS_BTN_DOWNLOAD_TITLE' | trns }}"
                                               placement="top"
                                               class="action">
                                                <ion-icon name="download"></ion-icon>
                                            </a>
                                            <a *ngIf="appointment.status === 4  && !appointment.past"
                                               (click)="generate(appointment);"
                                               data-container="body"
                                               title="{{ 'APPOINTMENTS_BTN_DOWNLOAD_TITLE' | trns }}"
                                               placement="top"
                                               class="action">
                                                <ion-icon name="download"></ion-icon>
                                            </a>
                                        </ng-container>
                                        <ng-container
                                                      *ngIf="(appointment.participantStatus === 1 || (appointment.participantStatus === 0 && appointment.invitation_message?.participant_id == user.selected_participant_id))  && !appointment.past">
                                            <a (click)="openAnswerAppointment(appointment, 3)"
                                               title="{{ 'APPOINTMENTS_BTN_CANCEL_TITLE' | trns }}"
                                               class="action cancel">
                                                <ion-icon name="close"></ion-icon>
                                            </a>
                                        </ng-container>
                                        <ng-container *ngIf="appointment.status === 4">
                                            <a (click)="openCancelPersonalAppointment(appointment)"
                                               title="{{ 'APPOINTMENTS_BTN_CANCEL_TITLE' | trns }}"
                                               class="action cancel">
                                                <ion-icon name="close"></ion-icon>
                                            </a>
                                        </ng-container>
                                    </ion-col>
                                </ion-row>
                            </ng-container>

                        </ion-grid>

                        <!-- mobile view of appointment lists -->
                        <ng-container *ngIf="plt.sizeSm">
                            <ng-container *ngFor="let appointment of processedAppointments">
                                <ion-row class="ion-no-padding item mobile ion-align-items-center with-invited">
                                    <ion-col size="11"
                                             class="ion-no-padding">

                                        <ion-row class="ion-no-padding">

                                            <ion-col [size]="appointment.participants?.length >= 3 ? 5 : ((appointment.participantStatus === 0 || appointment.participantStatus === 1) ? 4 : 3)"
                                                     class="ion-no-padding">
                                                <ng-container *ngIf="appointment.status == 4">
                                                    <span class="flex">
                                                        <ion-avatar class="ion-align-self-center">
                                                            <img img-avatar
                                                                 src="/assets/icons/private-lock.svg">
                                                        </ion-avatar>
                                                    </span>
                                                </ng-container>
                                                <ng-container *ngIf="appointment.status != 4">
                                                    <div class="participant-pictures pointer">
                                                        <ng-container *ngFor="let attendee of appointment.participants; let i = index">
                                                            <span *ngIf="(i < 2 && (appointment.participantStatus === 0 || appointment.participantStatus === 1)) || (i < 3 && appointment.participantStatus != 0 && appointment.participantStatus != 1)"
                                                                  class="flex"
                                                                  [hidden]="attendee.id == user.selected_participant_id && appointment.participants?.length < 3"
                                                                  (click)="showAttendeeDetail(attendee)">
                                                                <ion-avatar class="ion-align-self-center">
                                                                    <img img-avatar
                                                                         [src]="user?.canPicture(attendee) ? attendee.picture_url : ''"
                                                                         [title]="attendee.getFullName()">
                                                                </ion-avatar>
                                                            </span>
                                                        </ng-container>
                                                        <span *ngIf="appointment.participantStatus === 0 || appointment.participantStatus === 1"
                                                              class="flex add-participant"
                                                              (click)="addParticipants(appointment)">
                                                            +
                                                        </span>
                                                    </div>
                                                </ng-container>
                                            </ion-col>
                                            <ion-col [size]="appointment.participants?.length >= 3 ? 7 : ((appointment.participantStatus === 0 || appointment.participantStatus === 1) ? 8 : 9)"
                                                     class="ion-no-padding">
                                                <div>
                                                    <ng-container *ngIf="appointment.status == 4">
                                                        <span class="flex">
                                                            <ion-label class="ion-align-self-center">{{ 'APPOINTMENTS_PERSONAL_APPOINTMENT' | trns }}</ion-label>
                                                        </span>
                                                    </ng-container>
                                                    <ng-container *ngIf="appointment.status != 4">
                                                        <span *ngIf="appointment.participants?.length >= 3"
                                                              class="more"
                                                              (click)="openAppointmentParticipants($event, appointment)">
                                                            {{ 'BUTTON_SHOW_ALL' | trns }}
                                                        </span>
                                                        <ng-container *ngIf="appointment.participants?.length < 3">
                                                            <ng-container *ngFor="let attendee of appointment.participants; let i = index">
                                                                <span *ngIf="attendee.id != user.selected_participant_id"
                                                                      (click)="showAttendeeDetail(attendee)"
                                                                      class="more">
                                                                    {{ attendee.getFullName() | cut:22:'...':false }}
                                                                    <ng-container *ngIf="attendee.company"><br /><span class="company">{{attendee.company}}</span></ng-container>
                                                                </span>
                                                            </ng-container>
                                                        </ng-container>
                                                    </ng-container>
                                                </div>
                                                <span class="attendee-time">
                                                    <ng-container *ngIf="!appointment.date_ends_at">
                                                        {{ appointment.date_starts_at | datex: 'dateFormatDefault' }} – {{ appointment.date_starts_at | datex: 'timeFormatDefault' }}
                                                    </ng-container>
                                                    <ng-container *ngIf="appointment.date_ends_at">
                                                        {{ appointment.date_starts_at | datex: 'dateFormatDefault' }}<br />
                                                        <strong>{{ appointment.date_starts_at | datex: 'timeFormatDefault' }} - {{ appointment.date_ends_at | datex: 'timeFormatDefault' }}</strong>
                                                    </ng-container>
                                                </span>
                                            </ion-col>

                                        </ion-row>

                                        <ng-container *ngIf="appointment.online && (appointment.participants?.length <= 2 || appointment.participantStatus === 1)">
                                            <a (click)="openCall(appointment)"> {{'ATTENDEE_DETAIL_CALL_START' | trns}}</a>
                                        </ng-container>
                                        <ng-container *ngIf="appointment.online && appointment.participants?.length > 2 && appointment.participantStatus !== 1">{{'ATTENDEE_DETAIL_CALL_START' |
                                            trns}}</ng-container>
                                        <ng-container *ngIf="!appointment.online">{{appointment.location}}</ng-container>
                                        <div class="status">
                                            <span class="pending"
                                                  *ngIf="appointment.participantStatus === 0"><span class="dot"></span>{{ 'APPOINTMENTS_STATUS_PENDING' | trns }}</span>
                                            <span class="confirmed"
                                                  *ngIf="appointment.participantStatus === 1"><span class="dot"></span>{{ 'APPOINTMENTS_STATUS_CONFIRMED' | trns }}</span>
                                            <span class="personal"
                                                  *ngIf="appointment.status === 4"><span class="dot"></span>{{ 'APPOINTMENTS_STATUS_PERSONAL' | trns }}</span>
                                            <span class="canceled"
                                                  *ngIf="appointment.participantStatus === 2 || appointment.participantStatus === 3"><span class="dot"></span>{{ 'APPOINTMENTS_STATUS_CANCELED' | trns
                                                }}</span>
                                        </div>
                                        {{ appointment.description }}

                                    </ion-col>
                                    <ion-col size="1"
                                             class="ion-no-padding ion-text-center">
                                        <ng-container *ngIf="!appointment.past && (appointment.participantStatus === 1 || appointment.status === 4 )">
                                            <a *ngIf="appointment.participantStatus === 1  && !appointment.past"
                                               (click)="download(appointment);"
                                               data-container="body"
                                               title="{{ 'APPOINTMENTS_BTN_DOWNLOAD_TITLE' | trns }}"
                                               placement="top"
                                               class="action">
                                                <ion-icon name="download"></ion-icon>
                                            </a>
                                            <a *ngIf="appointment.status === 4  && !appointment.past"
                                               (click)="generate(appointment);"
                                               data-container="body"
                                               title="{{ 'APPOINTMENTS_BTN_DOWNLOAD_TITLE' | trns }}"
                                               placement="top"
                                               class="action">
                                                <ion-icon name="download"></ion-icon>
                                            </a>
                                            <br />
                                            <br />
                                            <br />
                                        </ng-container>
                                        <ng-container
                                                      *ngIf="(appointment.participantStatus === 1 || (appointment.participantStatus === 0 && appointment.invitation_message?.participant_id == user.selected_participant_id))  && !appointment.past">
                                            <a (click)="openAnswerAppointment(appointment, 3)"
                                               title="{{ 'APPOINTMENTS_BTN_CANCEL_TITLE' | trns }}"
                                               class="action cancel">
                                                <ion-icon name="close"></ion-icon>
                                            </a>
                                        </ng-container>
                                        <ng-container *ngIf="appointment.status === 4">
                                            <a (click)="openCancelPersonalAppointment(appointment)"
                                               title="{{ 'APPOINTMENTS_BTN_CANCEL_TITLE' | trns }}"
                                               class="action cancel">
                                                <ion-icon name="close"></ion-icon>
                                            </a>
                                        </ng-container>
                                    </ion-col>
                                </ion-row>
                            </ng-container>
                        </ng-container>

                    </ng-container>

                    <ng-container *ngIf="!processedAppointments?.length">
                        <div class="empty-data">
                            <svg-icon [applyClass]="true"
                                      src="/assets/icons/ico-calendar-empty.svg"
                                      class="icon fill-light"></svg-icon>
                            <ng-container *ngIf="upcomingAppointments">
                                <h3>
                                    {{ 'APPOINTMENTS_SOME_UPCOMINGS' | trns }}
                                </h3>
                            </ng-container>
                            <ng-container *ngIf="!upcomingAppointments">
                                <h3>
                                    {{ 'APPOINTMENTS_NO_UPCOMINGS_' + filterStatusValue | trns }}
                                </h3>
                                <p *ngIf="filterStatusValue=='pending' || filterStatusValue == 'confirmed'"
                                   [routerDirection]="'root'"
                                   [routerLink]="[plt.defaultLink + '/home/attendees/list']">
                                    {{ 'APPOINTMENTS_NO_UPCOMINGS_TEXT_1' | trns }}
                                    <a class="pointer">{{ 'APPOINTMENTS_NO_UPCOMINGS_TEXT_ANCHOR' | trns }}</a>{{ 'APPOINTMENTS_NO_UPCOMINGS_TEXT_2' | trns }}
                                </p>
                                <p *ngIf="event.use_timeslots && filterStatusValue=='personal'"
                                   [routerDirection]="'root'"
                                   [routerLink]="['/timeslots']">
                                    {{ 'APPOINTMENTS_NO_UPCOMINGS_PERSONAL_TEXT_1' | trns }}
                                    <a>{{ 'APPOINTMENTS_NO_UPCOMINGS_PERSONAL_TEXT_ANCHOR' | trns }}</a>{{ 'APPOINTMENTS_NO_UPCOMINGS_PERSONAL_TEXT_2' | trns }}
                                </p>
                            </ng-container>
                            <ion-button *ngIf="upcomingAppointments || filterUsed()"
                                        [routerLink]="[plt.defaultLink + '/appointments']"
                                        (click)="resetFilter()"
                                        color="primary">
                                {{ 'BUTTON_SHOW_ALL' | trns }}
                            </ion-button>
                        </div>
                    </ng-container>

                </div>

                <div class="list past"
                     *ngIf="pastAppointments?.length">
                    <div class="header">
                        <ion-grid class="ion-padding-top">
                            <ion-row class="ion-no-padding">
                                <ion-col size="12"
                                         class="ion-no-padding">
                                    <h2 [innerHTML]="'APPOINTMENTS_PAST_LABEL' | trns"></h2>
                                </ion-col>
                            </ion-row>
                        </ion-grid>
                    </div>

                    <ion-grid *ngIf="!plt.sizeSm"
                              class="ion-no-padding">
                        <ng-container *ngFor="let appointment of pastAppointments; let counter = index">
                            <ion-row class="item ion-align-items-center"
                                     [hidden]="counter >= pastAppointmentsCounter"
                                     [ngClass]="{'with-invited': appointment.participants?.length >= 3}">
                                <ion-col class="col-25p">

                                    <ng-container *ngIf="appointment.participants?.length < 3">
                                        <span *ngFor="let attendee of appointment.participants"
                                              [hidden]="attendee.id == user.selected_participant_id">
                                            <a (click)="showAttendeeDetail(attendee)"
                                               class="flex"
                                               [title]="attendee.getFullName()">
                                                <ion-avatar class="ion-align-self-center">
                                                    <img img-avatar
                                                         [src]="attendee.picture_url">
                                                </ion-avatar>
                                                <ion-label class="ion-align-self-center">
                                                    {{ attendee.getFullName() | cut:22:'...':false}}
                                                    <ng-container *ngIf="attendee.company"><br /><span class="company">{{attendee.company}}</span></ng-container>
                                                </ion-label>
                                            </a>
                                        </span>
                                        <span *ngIf="appointment.status == 4"
                                              class="flex">
                                            <ion-avatar class="ion-align-self-center">
                                                <img img-avatar
                                                     src="/assets/icons/private-lock.svg">
                                            </ion-avatar>
                                            <ion-label class="ion-align-self-center">{{ 'APPOINTMENTS_PERSONAL_APPOINTMENT' | trns }}</ion-label>
                                        </span>
                                    </ng-container>

                                    <ng-container *ngIf="appointment.participants?.length >= 3">
                                        <a class="participant-pictures pointer"
                                           (click)="openAppointmentParticipants($event, appointment)">
                                            <ng-container *ngFor="let attendee of appointment.participants; let i = index">
                                                <span *ngIf="i < 3"
                                                      class="flex">
                                                    <ion-avatar class="ion-align-self-center">
                                                        <img img-avatar
                                                             [src]="user?.canPicture(attendee) ? attendee.picture_url : ''"
                                                             [title]="attendee.getFullName()">
                                                    </ion-avatar>
                                                </span>
                                            </ng-container>
                                            <span class="more">{{ 'BUTTON_SHOW_ALL' | trns }}</span>
                                        </a>
                                    </ng-container>
                                </ion-col>
                                <ion-col class="col-20p">
                                    <ng-container *ngIf="!appointment.date_ends_at">
                                        {{ appointment.date_starts_at | datex: 'dateFormatDefault' }} – {{ appointment.date_starts_at | datex: 'timeFormatDefault' }}
                                    </ng-container>
                                    <ng-container *ngIf="appointment.date_ends_at">
                                        {{ appointment.date_starts_at | datex: 'dateFormatDefault' }}<br />
                                        {{ appointment.date_starts_at | datex: 'timeFormatDefault' }} - {{ appointment.date_ends_at | datex: 'timeFormatDefault' }}
                                    </ng-container>
                                </ion-col>
                                <ion-col class="col-15p">
                                    <ng-container *ngIf="appointment.online">
                                        <a (click)="openCall(appointment)"> {{'ATTENDEE_DETAIL_CALL_START' | trns}}</a>
                                    </ng-container>
                                    <ng-container *ngIf="!appointment.online">{{appointment.location}}</ng-container>
                                </ion-col>
                                <ion-col class="col-15p">{{ appointment.description }}</ion-col>
                                <ion-col class="status col-15p">
                                    <span class="passed"><span class="dot"></span>{{ 'APPOINTMENTS_STATUS_PASSED' | trns }}</span>
                                </ion-col>
                                <ion-col class="more col-10p last"></ion-col>
                            </ion-row>
                        </ng-container>

                    </ion-grid>

                    <!-- mobile view of appointment lists -->
                    <ng-container *ngIf="plt.sizeSm">
                        <ng-container *ngFor="let appointment of pastAppointments">
                            <ion-row class="ion-align-items-center ion-no-padding item mobile"
                                     [ngClass]="{'with-invited': appointment.participants?.length >= 3}">
                                <ion-col size="11"
                                         class="ion-no-padding">
                                    <ion-row class="ion-no-padding">

                                        <ng-container *ngIf="appointment.participants?.length < 3">
                                            <ion-col size="3"
                                                     class="ion-no-padding">
                                                <span *ngFor="let attendee of appointment.participants"
                                                      [hidden]="attendee.id == user.selected_participant_id">
                                                    <ion-avatar *ngIf="appointment.participantStatus != 4"
                                                                (click)="showAttendeeDetail(attendee)"
                                                                class="ion-align-self-center">
                                                        <img img-avatar
                                                             [src]="attendee.picture_url">
                                                    </ion-avatar>
                                                </span>

                                                <ion-avatar *ngIf="appointment.status == 4"
                                                            class="ion-align-self-center">
                                                    <img img-avatar
                                                         src="/assets/icons/private-lock.svg">
                                                </ion-avatar>
                                            </ion-col>
                                            <ion-col size="9"
                                                     class="ion-no-padding">
                                                <span *ngFor="let attendee of appointment.participants"
                                                      class="attendee-name"
                                                      [hidden]="attendee.id == user.selected_participant_id">
                                                    <a (click)="showAttendeeDetail(attendee)"
                                                       class="flex"
                                                       [title]="attendee.getFullName()">
                                                        {{ attendee.getFullName() | cut:22:'...':false }}
                                                        <ng-container *ngIf="attendee.company"><br /><span class="company">{{attendee.company}}</span></ng-container>
                                                    </a>
                                                </span>

                                                <span *ngIf="appointment.status == 4"
                                                      class="attendee-name ion-align-self-center">
                                                    {{ 'APPOINTMENTS_PERSONAL_APPOINTMENT' | trns }}
                                                </span>

                                                <span class="attendee-time">
                                                    <ng-container *ngIf="!appointment.date_ends_at">
                                                        {{ appointment.date_starts_at | datex: 'dateFormatDefault' }} – {{ appointment.date_starts_at | datex: 'timeFormatDefault' }}
                                                    </ng-container>
                                                    <ng-container *ngIf="appointment.date_ends_at">
                                                        {{ appointment.date_starts_at | datex: 'dateFormatDefault' }}<br />
                                                        <strong>{{ appointment.date_starts_at | datex: 'timeFormatDefault' }} - {{ appointment.date_ends_at | datex: 'timeFormatDefault' }}</strong>
                                                    </ng-container>
                                                </span>
                                            </ion-col>
                                        </ng-container>

                                        <ng-container *ngIf="appointment.participants?.length >= 3">
                                            <ion-col size="5"
                                                     class="ion-no-padding">

                                                <a class="participant-pictures pointer"
                                                   (click)="openAppointmentParticipants($event, appointment)">
                                                    <ng-container *ngFor="let attendee of appointment.participants; let i = index">
                                                        <span *ngIf="i < 3"
                                                              class="flex">
                                                            <ion-avatar class="ion-align-self-center">
                                                                <img img-avatar
                                                                     [src]="user?.canPicture(attendee) ? attendee.picture_url : ''"
                                                                     [title]="attendee.getFullName()">
                                                            </ion-avatar>
                                                        </span>
                                                    </ng-container>
                                                </a>
                                            </ion-col>
                                            <ion-col size="7"
                                                     class="ion-no-padding">
                                                <a (click)="openAppointmentParticipants($event, appointment)"
                                                   class="more">{{ 'BUTTON_SHOW_ALL' | trns }}</a>
                                                <span class="attendee-time">
                                                    <ng-container *ngIf="!appointment.date_ends_at">
                                                        {{ appointment.date_starts_at | datex: 'dateFormatDefault' }} – {{ appointment.date_starts_at | datex: 'timeFormatDefault' }}
                                                    </ng-container>
                                                    <ng-container *ngIf="appointment.date_ends_at">
                                                        {{ appointment.date_starts_at | datex: 'dateFormatDefault' }}<br />
                                                        <strong>{{ appointment.date_starts_at | datex: 'timeFormatDefault' }} - {{ appointment.date_ends_at | datex: 'timeFormatDefault' }}</strong>
                                                    </ng-container>
                                                </span>
                                            </ion-col>
                                        </ng-container>

                                    </ion-row>

                                    {{ appointment.location }}
                                    <div class="status">
                                        <span class="passed"><span class="dot"></span>{{ 'APPOINTMENTS_STATUS_PASSED' | trns }}</span>
                                    </div>
                                    {{ appointment.description }}

                                </ion-col>

                            </ion-row>
                        </ng-container>
                    </ng-container>

                    <ion-item class="load-more ion-justify-content-center"
                              *ngIf="pastAppointmentsCounter < pastAppointments?.length">
                        <ion-button (click)="loadMorePast()"
                                    color="primary">
                            {{ 'BUTTON_LOAD_MORE' | trns }}
                        </ion-button>
                    </ion-item>

                </div>

            </div>
        </div>

    </div>
    <ng-container *ngIf="loading">
        <div class="content-centered-column">
            <div class="content-centered-row">
                <ion-spinner></ion-spinner>
            </div>
        </div>
    </ng-container>
</ion-content>